import styled from "styled-components";
import { ChartCard as BaseChartCard } from "./live-rdc";

export const ChartCard = styled(BaseChartCard)`
  margin: 1.6rem 0 2.4rem;
`;
